type SupportBotConfig = {
  key: string;
  signedJWTUrl: string;
  tokenFieldId: string;
};

export const SUPPORT_BOT_CONFIG: SupportBotConfig = {
  key: window.__app_config.WEBUI_SUPPORT_BOT_PUBLIC_KEY,
  signedJWTUrl: window.__app_config.WEBUI_SUPPORT_SIGNED_JWT_URL,
  tokenFieldId: window.__app_config.WEBUI_SUPPORT_TOKEN_FIELD_ID,
};
